<template>
	<div class="component comments-modal modal">
		
		<button
			type="button"
			class="comments-modal__trigger"
			:class="{ 'comments-modal__trigger--navbar': navBarItem }"
			aria-label="Reacties openen"
			@click="open()"
		>
			<MessageSquareText :size="18" :stroke-width="2" />
			<span class="total-comments">{{ totalComments }}</span>
			<span class="uk-visible@m" v-show="showLabel">reactie<span v-show="totalComments != 1">s</span></span>
		</button>
	
		<VueSidePanel
				v-model="sidePanel"
				:lock-scroll="false"
				side="right"
				width="800px"
				:hide-close-btn="true"
			>
				<template #header>
					<div class="side-panel-header uk-padding-small">
						<div class="uk-grid uk-grid-collapse uk-flex uk-flex-middle">
							<div class="uk-width-auto">
								<h4 class="uk-margin-remove icon"><MessageSquareText :size="20" :stroke-width="2" /></h4>
							</div>
							<div class="uk-width-expand uk-relative">
								<h4 class="text">Reacties</h4>
							</div>
							<div class="uk-width-auto uk-text-right">
								<a href="javascript:void(0)" class="uk-icon-button" style="background: transparent" @click="close" uk-icon="close"></a>
							</div>
						</div>
					</div>
				</template>
					<template #default>
				 <div class="uk-padding uk-text-left" style="padding-bottom: 80px">
					 <comments-loader 
						 v-if="sidePanel"
						 :url="url"
						 :js-variables="jsVariables" 
						 :auto-load="true"
					 ></comments-loader>
				 </div>				 
				 </template>
				<template #footer>
					<a href="javascript:void(0)" class="uk-icon-button" style="background: transparent" @click="close" uk-icon="close"></a>
				</template>			 
				 
		</VueSidePanel>
				 
	</div>
</template>

<script setup lang="ts">

// Swiper
import swipeModal from '@takuma-ru/vue-swipe-modal';
import { ref, onMounted, onBeforeMount } from 'vue';
import axios from 'axios';
import MessageSquareText from '@lucide/vue/dist/esm/icons/message-square-text.mjs';

// Own components
import LoadingIndicator from './LoadingIndicator.vue'
import CommentsLoader from './CommentsLoader.vue'

// Refs
const bottomModal = ref(false);
const sidePanel = ref(false);
const isLoading = ref(true);
const modalContent = ref('');
const localContentsWidth = ref<string>('');

// Helper 
import helper from '../js/helper';

// Open
const open = () => {

	if(props.nativeModal) {
		// Open native model in app, so send and event 
		helper.sendAppMessage({
			action: 'showCommentsModal',
			elementId: props.jsVariables.settings.element.id
		})
	}	else {
		
		// default side panel (web)
		sidePanel.value = true;
	}
};

// Close
const close = () => {
	sidePanel.value = false;
};

// Opened
const opened = () => {
	//console.log('opened!');
};

// Props
const props = defineProps({
	totalComments: {
		type: Number,
		required: false
	},
	url: {
		type: String,
		required: true
	},
	jsVariables: {
		type: Object,
		required: true
	},
	contentsWidth: {
		type: String
	},
	navBarItem: {
		type: Boolean,
		required: false,
		default: false
	},
	showLabel: {
		type: Boolean,
		required: false,
		default: true
	},
	nativeModal: {
		type: Boolean,
		required: false,
		default: false		
	},
});

// Load content
const loadContent = async () => {
	
	console.log('app/components/comments-loader/loadContent');
	
	if(!props.elementId) return;

	try {
		const response = await axios.get('/async/comments?id=' + props.elementId + '&notificationSubscribeEnabled=' + props.notificationSubscribeEnabled);
		modalContent.value = response.data;
		isLoading.value = false;
	} catch (error) {
		console.error('Error loading remote URL:', error);
		isLoading.value = false;
	}
}
// On Mounted
onMounted(async () => {
});

// Before Mount
onBeforeMount(() => {
	
		// Set modal width for desktop vs mobile
		const viewportWidth = window.innerWidth;
		const breakpoint = 768;

		if (viewportWidth > breakpoint) {
				localContentsWidth.value = "80%";
		} else {			
				localContentsWidth.value = "100%";
		}
});

</script>

<style scoped>	
	
.component.comments-modal {
	display: inline-flex;
}
.comments-modal__trigger {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	height: 36px;
	min-width: 36px;
	padding: 0 9px;
	border: 1px solid #e1e4e8;
	border-radius: 7px;
	background: #f5f6f7;
	color: #686e76;
	font: inherit;
	cursor: pointer;
	transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}
.comments-modal__trigger:hover,
.comments-modal__trigger:focus-visible {
	border-color: rgba(255, 61, 0, 0.28);
	background: rgba(255, 61, 0, 0.08);
	color: var(--tint-color);
	outline: none;
}
.component.comments-modal .total-comments {
	font-size: 0.88rem;
	font-variant-numeric: tabular-nums;
	line-height: 1;
}
:global(body.dark .comments-modal__trigger) {
	border-color: #343943;
	background: #242830;
	color: #b3b9c2;
}
:global(body.dark .comments-modal__trigger:hover),
:global(body.dark .comments-modal__trigger:focus-visible) {
	border-color: rgba(255, 61, 0, 0.38);
	background: rgba(255, 61, 0, 0.12);
	color: #ff6333;
}

/* header */
.side-panel-header { 
	background: #20202C;
}
.side-panel-header .icon,
.site-panel-header svg {
	color: #f4f4f4;
	fill: #f4f4f4;
}
.side-panel-header .text {
	color: #f4f4f4;
	margin-left: 15px;
}

/* dark mode */
body.dark #vsp-container > div.vsp-wrapper.vsp-wrapper--active > div.vsp.vsp--right-side {
	background: blue !important;
}
body.dark .vsp.vsp--right-side {
	background: red !important;
}
</style>
